/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/settings/user', {
      templateUrl: require('./user-settings.template.html'),
      title: 'Benutzereinstellungen',
    });
}
